/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeRevokeMandateSigningCommand, type ProblemDetails, type RevokeMandateSigningCommand } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}/mandate/signing/revoke
 */
export interface RevokeRequestBuilder extends BaseRequestBuilder<RevokeRequestBuilder> {
    /**
     * RevokeMandateSigning
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: RevokeMandateSigningCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * RevokeMandateSigning
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RevokeMandateSigningCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RevokeRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}/mandate/signing/revoke";
/**
 * Metadata for all the requests in the request builder.
 */
export const RevokeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RevokeRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRevokeMandateSigningCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
